module.exports = __webpack_public_path__ + "static/media/Ridgewood-Hills-Deed-Restrictions.916fbe29.pdf";